// // src/app/schedules/newCalender/modals/ProductModal.tsx
// import React, {useEffect} from "react";
// import {Plus, Search, X} from "lucide-react";
//
// interface ProductModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     products:any
// }
//
// const ProductModal: React.FC<ProductModalProps> = ({ isOpen, onClose,products }) => {
//
//     useEffect(() => {
//         console.log('products in modal',products)
//     }, [products]);
//
//
//
//     if (!isOpen) return null
//
//     return (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
//                     <div className="flex items-center justify-between p-6 border-b border-gray-200">
//                         <h2 className="text-xl font-semibold text-gray-900">Add Product</h2>
//                         <button
//                             onClick={onClose}
//                             className="p-2 hover:bg-gray-100 rounded-lg"
//                         >
//                             <X className="w-5 h-5" />
//                         </button>
//                     </div>
//
//                     <div className="p-6">
//                         {/* Search Bar */}
//                         <div className="mb-4">
//                             <div className="relative">
//                                 <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//                                 <input
//                                     type="text"
//                                     placeholder="Search products..."
//                                     className="w-full pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                                 />
//                             </div>
//                         </div>
//
//                         <div className="space-y-4">
//                             {[
//                                 { id: 1, name: 'Botox Vials', category: 'Injectables', price: 450, stock: 24 },
//                                 { id: 2, name: 'Hyaluronic Acid Filler', category: 'Injectables', price: 320, stock: 8 },
//                                 { id: 3, name: 'TCA Chemical Peel', category: 'Skin Treatments', price: 85, stock: 15 },
//                                 { id: 4, name: 'Laser Equipment Rental', category: 'Equipment', price: 200, stock: 3 },
//                                 { id: 5, name: 'Recovery Cream', category: 'Skincare', price: 45, stock: 32 },
//                                 { id: 6, name: 'Numbing Gel', category: 'Supplies', price: 25, stock: 18 }
//                             ].map((product) => (
//                                 <div
//                                     key={product.id}
//                                     className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
//                                     onClick={() => {
//                                         // addProductToCheckout(product);
//                                         // setShowProductModal(false);
//                                     }}
//                                 >
//                                     <div className="flex-1">
//                                         <div className="flex items-center justify-between">
//                                             <h3 className="text-sm font-medium text-gray-900">{product.name}</h3>
//                                             <span className="text-sm font-semibold text-gray-900">${product.price}</span>
//                                         </div>
//                                         <div className="flex items-center space-x-4 mt-1">
//                        <span className="inline-flex px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
//                           {product.category}
//                         </span>
//                                             <span className="text-xs text-gray-500">
//                           {product.stock} in stock
//                         </span>
//                                         </div>
//                                     </div>
//                                     <div className="ml-4">
//                                         <Plus className="w-5 h-5 text-gray-400" />
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//
//     );
// };
//
// export default ProductModal;



import React, { useEffect, useMemo, useState } from "react";
import {Minus, Plus, Search, X} from "lucide-react";
import {DraftProduct} from "../hooks/useUpdateAppointmentNew";

interface Product {
    id: number;
    title: string;
    description: string;
    priceCents: number;
    stock: number;
    productCategoryId: number;
}

interface SelectedProduct {
    productId: number;
    quantity: number;
}

interface ProductModalProps {
    isOpen: boolean;
    onClose: () => void;
    products: any;
    selectedProducts:any;
    onAddProduct: (product: Product) => void;
    onRemoveProduct: (product: Product) => void;
}

// const getSelectedQuantity = (
//     productId: number,
//     selectedProducts: Product[]
// ) => {
//     return selectedProducts.filter(p => p.id === productId).length;
// };

const getSelectedQuantity = (
    productId: number,
    selectedProducts: DraftProduct[]
) => {
    return selectedProducts.find(p => p.productId === productId)?.quantity ?? 0;
};

const ProductModal: React.FC<ProductModalProps> = ({
                                                       isOpen,
                                                       onClose,
                                                       products,
                                                       selectedProducts,
                                                       onRemoveProduct,
    onAddProduct
                                                   }) => {
    const [search, setSearch] = useState("");


    useEffect(() => {
        console.log('products in modal',products)
        console.log('selectedProducts',selectedProducts)

    }, [products,selectedProducts]);
    // 🔹 Flatten categories → products with category name
    const flatProducts = useMemo(() => {
        return products ? products?.flatMap((category:any) =>
            category?.products?.map((product:any) => ({
                ...product,
                categoryName: category.name
            }))
        ) :[]
    }, [products]);




    // 🔹 Search filter
    const filteredProducts = useMemo(() => {
        return flatProducts?.filter((p:any) =>
            p.title.toLowerCase().includes(search.toLowerCase())
        );
    }, [flatProducts, search]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">

                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-semibold">Add Product</h2>
                    <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-6">
                    {/* Search */}
                    <div className="mb-4 relative">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search products..."
                            className="w-full pl-9 pr-4 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {/* Product List */}
                    <div className="space-y-3">
                        {filteredProducts?.map((product:any) => {
                            // const selectedQty = getSelectedQuantity(product.id, selectedProducts);
                            // const remainingStock = product.stock - selectedQty;

                            const selectedQty = getSelectedQuantity(product.id, selectedProducts);
                            const remainingStock = product.stock - selectedQty;

                            return (
                                <div
                                    key={product.id}
                                    className={`flex items-center justify-between p-3 border rounded-lg
                    `}

                                >

                                    <div className="flex-1">
                                        <div className="flex justify-between">
                                            <h3 className="text-sm font-medium">{product.title}</h3>
                                            <span className="text-sm font-semibold">
                        ${(product.priceCents / 100).toFixed(2)}
                      </span>
                                        </div>

                                        <div className="flex items-center space-x-4 mt-1">
                      <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full">
                        {product.categoryName}
                      </span>

                                            <span className="text-xs text-gray-500">
                        {remainingStock} remaining
                      </span>

                                            {selectedQty > 0 && (
                                                <span className="text-xs font-medium text-green-600">
                          {selectedQty} selected
                        </span>
                                            )}
                                        </div>
                                    </div>

                                    {/*<Minus  className={`w-5 h-5 text-gray-400 ml-4 ${remainingStock === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 cursor-pointer"}`}   onClick={() => remainingStock > 0 && onRemoveProduct(product)} />*/}
                                    {/*<Plus  className={`w-5 h-5 text-gray-400 ml-4 ${remainingStock === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 cursor-pointer"}`}   onClick={() => remainingStock > 0 && onAddProduct(product)} />*/}

                                    <Minus
                                        className={`w-5 h-5 ml-4
    ${selectedQty === 0
                                            ? "opacity-50 cursor-not-allowed"
                                            : "text-gray-400 hover:text-black cursor-pointer"
                                        }`}
                                        onClick={() => selectedQty > 0 && onRemoveProduct(product)}
                                    />

                                    <Plus
                                        className={`w-5 h-5 ml-4
    ${remainingStock === 0
                                            ? "opacity-50 cursor-not-allowed"
                                            : "text-gray-400 hover:text-black cursor-pointer"
                                        }`}
                                        onClick={() => remainingStock > 0 && onAddProduct(product)}
                                    />

                                </div>
                            );
                        })}

                        {filteredProducts?.length === 0 && (
                            <p className="text-sm text-gray-500 text-center py-6">
                                No products found
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductModal;
